// test788
(788 && 0);
